/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  storeFinderTranslationsEn,
  storeFinderTranslationsEs
} from '@spartacus/storefinder/assets';
import {
  STORE_FINDER_FEATURE,
  StoreFinderRootModule,
} from '@spartacus/storefinder/root';

@NgModule({
  imports: [StoreFinderRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [STORE_FINDER_FEATURE]: {
          module: () =>
            import('@spartacus/storefinder').then((m) => m.StoreFinderModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {en:storeFinderTranslationsEn, es: storeFinderTranslationsEs}
      },
    }),
  ],
})
export class StorefinderFeatureModule { }
